import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import { Box, Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin';
import {
    useMediaQuery
} from '@material-ui/core';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import colors from '../CustomizedUIs/Colors'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ExpandButton from '../CustomizedUIs/ExpandButton';

const useStyles = makeStyles((theme) => ({
    TextSubItemWhite: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#fafefe',
    },
    TextSubItem: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    borderRemove: {
        width: '30px',
        height: '30px',
        borderRadius: '10px',
        backgroundColor: '#ffffff',
    },
    borderAdd: {
        width: '30px',
        height: '30px',
        borderRadius: '10px',
        backgroundColor: '#e5f1f8',
    },
    borderCluster: {
        borderRadius: '10px',
        border: 'solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
        padding: '11px'
    },
    borderClusterOpen: {
        borderRadius: '10px',
        border: 'solid 1px #c1e5fa',
        backgroundColor: '#fafefe',
        padding: '11px'
    }, textCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#6cb5b8',
    },
    textClusterOpen: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#237fc2',
    },
    backGroud: {
        borderRadius: '10px',
        boxShadow: '0 3px 6px 0 rgba(27, 102, 157, 0.04)',
        backgroundColor: '#ffffff',
    },
    backgroundOpen: {
        borderRadius: '10px',
        boxShadow: ' 0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor:theme.palette.primary.main,
    }

}))


export default function SubItem({ children, name, countCluster }) {
    const translate = useTranslate();
    const classes = useStyles();
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const theme=useTheme()
    const [open, setOpen] = React.useState(false)

    const handleClick = () => {
        setOpen(!open)
    }

    return (
        <Box borderRadius='10px' className={open ? classes.backgroundOpen : classes.backGroud}>
            <Box style={{ cursor: 'pointer' }} display='flex' width='100%'>
                <Box width='10px' bgcolor={open ? '#ffffff' :theme.palette.secondary.main} style={{ opacity: open ? 0.2 : 1, borderTopLeftRadius: '10px', borderBottomLeftRadius: open ? 0 : '10px' }}></Box>
                <ListItem onClick={handleClick} style={{ paddingTop: '11px', paddingBottom: '11px' }}>
                    <ListItemText primary={<Typography className={!open ? classes.TextSubItem : classes.TextSubItemWhite}>{name}</Typography>} />
                    <Box borderRadius='10px' width='79px' textAlign='center' className={!open ? classes.borderCluster : classes.borderClusterOpen} px={isDesktop ? 2 : 1} py={1} mr={isDesktop ? 10 : 1} >
                        <Typography className={!open ? classes.textCluster : classes.textClusterOpen} > {(countCluster + " " + translate(countCluster <= 1 ? `resources.group.cluster` : `resources.group.clusters`)).toUpperCase()}</Typography>
                    </Box>
                    <ExpandButton open={open} color={theme.squareButon.content}/>
                </ListItem>
            </Box>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box display='flex'>
                    <Box width='4px' bgcolor={theme.palette.secondary.main}></Box>
                    <Box bgcolor='background.paper' width='100%'>
                        <List component="div" disablePadding>
                            {children}
                        </List>
                    </Box>
                </Box>
            </Collapse>

        </Box>
    );
}
